import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=05407da8&scoped=true&"
import script from "./Icons.vue?vue&type=script&lang=ts&"
export * from "./Icons.vue?vue&type=script&lang=ts&"
import style0 from "./Icons.vue?vue&type=style&index=0&id=05407da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05407da8",
  null
  
)

export default component.exports